<div class="flex gap-3 items-center flex-0 h-8">
	@if (icon(); as icon) {
		<mar-icon size="s" [name]="icon" />
	}

	<h3 class="font-semibold text-lg">
		{{ label() | transloco }}
	</h3>

	@if (tooltip(); as tooltip) {
		<tui-icon
			tabindex="0"
			class="ml-[-6px]"
			icon="@tui.info"
			size="s"
			[tuiHint]="tooltip | transloco"
			tuiHintDescribe
		/>
	}

	<span class="flex-1"></span>

	@if (cardTypes().length) {
		<div>
			<tui-segmented
				size="s"
				[(activeItemIndex)]="activeTypeIndex"
				(activeItemIndexChange)="onTypeChange()"
			>
				@for (cardType of cardTypes(); track cardType.type) {
					<button type="button">
						<tui-icon [icon]="cardType.icon" />
					</button>
				}
			</tui-segmented>
		</div>
	}
</div>

<div class="flex-1 px-2 flex flex-col">
	<ng-content />
</div>
